ACC.addToCartPdpLearner = {

    _autoload: [
        ['bindToAddToCartForm', $('.add-to-cart-learner-pdp').length !== 0],
    ],

    bindToAddToCartForm() {
        $('.js-enable-btn').removeClass('button--disabled');
        const addToCartForm = $('.add-to-cart-learner-pdp');
        addToCartForm.ajaxForm({
            success: ACC.addToCartPdpLearner.updateCartOnSuccess,
            complete: ACC.addToCartPdpLearner.enableAddToCartButton,
        });
        addToCartForm.each(function (index, formElement) {
            const productCode = $(this).data('productCode');
            $(`.js-add-to-cart[data-product-code="${productCode}"]`).on('click', function (e) {
                e.preventDefault();
                ACC.buttonhelper.disable(this);
                $(formElement).submit();
            });
        });
    },

    updateCartOnSuccess(cartResult, statusText, xhr, formElement) {
        ACC.cartgtm.addToCartGtm(cartResult.ecom_addtocart);
        ACC.addToCartPdpLearner.updateCartStatus(cartResult, formElement);
        if (cartResult.isFeatureAddToCartModelEnabled && cartResult.isFeatureAddToCartModelEnabled === 'true') {
            ACC.addToCartPdpLearner.displayAddToCartPopup(cartResult, formElement);
            ACC.addToCartPdpLearner.closeFreePreviewPopup();
        } else {
            const url = `${ACC.config.encodedContextPath}/cart`;
            window.location.replace(url);
        }
    },

    updateCartStatus(cartResult) {
        ACC.minicart.updateMiniCartDisplay(cartResult.cartData.totalCartItemsCount);
    },

    displayAddToCartPopup(cartResult) {
        $modal.open(null, {
            html: cartResult.addToCartLearnerLayer,
        });
    },

    closeFreePreviewPopup() {
        if ($('#myModal').is(':visible')) {
            $('.prototype-video__modalClose').click();
        }
    },

    enableAddToCartButton() {
        ACC.buttonhelper.enable('.js-add-to-cart');
    },

};
